import request from '@/utils/request'

// 根据设备id查询设备配置详细
export function getDeviceConfigByDeviceId(id) {
  return request({
    url: '/iot/deviceConfig/byDeviceId/' + id,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/deviceConfig.js